/* eslint jsx-a11y/no-noninteractive-element-interactions: 0, jsx-a11y/no-noninteractive-tabindex: 0 */

import clsx from 'clsx';
import React, { useState, useEffect } from 'react';

interface ShowMoreProps {
	isShown?: boolean;
	children?: React.ReactNode;
	onShowMoreChanged?: (element: HTMLDivElement | null) => void;
	hasChildSelected?: boolean;
	label?: string | React.ReactNode;
}

const ShowMore: React.FC<ShowMoreProps> = (props) => {
	const { isShown, children, onShowMoreChanged, hasChildSelected, label } =
		props;
	const [isFocused, setIsFocused] = useState(false);
	const [isHidden, setIsHidden] = useState(true);
	const onKeyDown = (event: KeyboardEvent) => {
		if (event.keyCode === 13) {
			if (isFocused) {
				setIsHidden(!isHidden);
			} else if (!isHidden) {
				setIsHidden(isHidden);
			}
		}
	};

	const close = () => {
		if (!isHidden) {
			setIsHidden(true);
		}
	};
	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.addEventListener('click', close);
			window.addEventListener('keydown', onKeyDown);
		}
	}, []);

	if (!isShown || !children || !(children as any).length) {
		return null;
	}

	const onFocus = () => setIsFocused(true);

	const onBlur = () => setIsFocused(true);

	const toggleVisibility = (event: React.MouseEvent) => {
		event.stopPropagation();
		setIsHidden(!isHidden);
	};

	const isListHidden = isHidden;
	const showMoreStyles = clsx({
		RRT__showmore: true,
		'RRT__showmore--opened': !isListHidden,
		'RRT__showmore--selected': hasChildSelected,
	});

	const listStyles = clsx({
		'RRT__showmore-list': true,
		'RRT__showmore-list--opened': !isListHidden,
	});

	const showMoreLabelStyles = clsx({
		'RRT__showmore-label': true,
		'RRT__showmore-label--selected': !isListHidden,
	});
	return (
		<div
			ref={onShowMoreChanged}
			className={showMoreStyles}
			role="navigation"
			tabIndex={0}
			onBlur={onBlur}
			onClick={toggleVisibility}
			onFocus={onFocus}
		>
			<div className={showMoreLabelStyles}>{label}</div>
			<div aria-hidden={isListHidden} className={listStyles} role="menu">
				{children}
			</div>
		</div>
	);
};



ShowMore.displayName = 'ShowMore';

export default ShowMore;
